import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import FullScreenLoader from "../../components/FullScreenLoader";

function PupilActivityEnrollmentModal({
  handleClose,
  rowData,
  selectedActivityId,
  selectedActivityType,
  activitiesData,
  nameField,
  slots,
  activityDetails,
  refreshOnSubmitSuccess,
}) {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm();

  const [studentsData, setStudentsData] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const selectedActivity = activitiesData.find(
    (activity) => activity.id === selectedActivityId
  );

  const fetchStudentsByActivityAndParentId = async () => {
    try {
      const response = await get(
        `CampusActivity/GetActivityStudentsByPrentSectionActivityId?activityId=${selectedActivityId}&userId=${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStudentsData(response || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    if (selectedActivityId) {
      fetchStudentsByActivityAndParentId();
    }
  }, [selectedActivityId]);

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formData = {
      id: 0,

      campusActivityId: rowData.id,
      campusActivityName: rowData.group,
      studentId: rowData.studentId,

      campusActivitySlotId: data?.campusActivitySlotId?.value,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(
        "CampusActivity/UpdateActivityPupilForm",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success("Success!");
        reset();
        handleClose();
        refreshOnSubmitSuccess();
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Activity Enrollment</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body pt-0">
              {activityDetails && (
                <div className="fs-9 mb-3">
                  <div className="row mb-2">
                    <div
                      className="activity-image-preview d-flex justify-content-center align-items-center p-0"
                      style={{ height: "150px" }}
                    >
                      {activityDetails.clubImagePath ||
                      activityDetails.tourImageUploadPath ? (
                        <img
                          src={`${
                            process.env.REACT_APP_LIVE_DOMAIN_URL
                          }ExternalImages${
                            activityDetails.clubImagePath ||
                            activityDetails.tourImageUploadPath
                          }`}
                          alt="Preview"
                        />
                      ) : (
                        <span className="fas fa-image fs-3 text-light"></span>
                      )}
                    </div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Activity Name:</strong>
                    <span>
                      {activityDetails.clubName || activityDetails.tourName}
                    </span>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Activity Type:</strong>
                    <span>{selectedActivityType}</span>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Start Date:</strong>
                    <div>
                      {new Date(
                        activityDetails.startDate || activityDetails.tourDate
                      ).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>End Date:</strong>
                    <div>
                      {new Date(
                        activityDetails.endDate || activityDetails.tourDate
                      ).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Description:</strong>
                    <div className="ps-1 text-end">
                      {activityDetails.description}
                    </div>
                  </div>
                  {activityDetails.destination && (
                    <div className="mb-2 d-flex justify-content-between border-bottom">
                      <strong>Destination:</strong>
                      <div>{activityDetails.destination}</div>
                    </div>
                  )}
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Minimum No of Participants:</strong>
                    <div>{activityDetails.minStudents}</div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Maximum No of Participants:</strong>
                    <div>{activityDetails.maxStudents}</div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Contact Name:</strong>
                    <div>{activityDetails.contactName}</div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Contact Email:</strong>
                    <div>{activityDetails.email}</div>
                  </div>
                  <div className="mb-2 d-flex justify-content-between border-bottom">
                    <strong>Contact Phone:</strong>
                    <div>{activityDetails.phone}</div>
                  </div>
                </div>
              )}

              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                {["SchoolClub", "AfterSchoolClub"].includes(
                  selectedActivityType
                ) && (
                  <div className="col-md-12">
                    <label className="form-label">
                      Time Slot (Start Time - End Time)
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <Controller
                      name="campusActivitySlotId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={slots.map((slot) => ({
                            value: slot.id,
                            label:
                              slot.name +
                              " (" +
                              slot.slotStartTime +
                              "-" +
                              slot.slotEndTime +
                              ")",
                          }))}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue("campusActivitySlotId", null);
                            } else {
                              setValue("campusActivitySlotId", selectedOption);
                            }
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                        />
                      )}
                    />
                    {errors.campusActivitySlotId && (
                      <small className="text-danger">
                        {errors.campusActivitySlotId.message}
                      </small>
                    )}
                  </div>
                )}
                {["Event", "FacilityRental"].includes(selectedActivityType) && (
                  <div className="col-md-12">
                    <label className="form-label">
                      Date (Start Time - End Time)
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <Controller
                      name="campusActivitySlotId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={slots.map((slot) => ({
                            value: slot.id,
                            label:
                              slot.eventDate.split("T")[0] +
                              " (" +
                              slot.startTime +
                              "-" +
                              slot.endTime +
                              ")",
                          }))}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue("campusActivitySlotId", null);
                            } else {
                              setValue("campusActivitySlotId", selectedOption);
                            }
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                        />
                      )}
                    />
                    {errors.campusActivitySlotId && (
                      <small className="text-danger">
                        {errors.campusActivitySlotId.message}
                      </small>
                    )}
                  </div>
                )}
                {["Tour"].includes(selectedActivityType) && (
                  <div className="col-md-12">
                    <label className="form-label">
                      Tour Date (Departure Time - Return Time)
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <Controller
                      name="campusActivitySlotId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={slots.map((slot) => ({
                            value: 0,
                            label:
                              slot.tourDate.split("T")[0] +
                              " (" +
                              slot.departureTime +
                              "-" +
                              slot.returnTime +
                              ")",
                          }))}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue("campusActivitySlotId", null);
                            } else {
                              setValue("campusActivitySlotId", selectedOption);
                            }
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                        />
                      )}
                    />
                    {errors.campusActivitySlotId && (
                      <small className="text-danger">
                        {errors.campusActivitySlotId.message}
                      </small>
                    )}
                  </div>
                )}
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm w-100"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Enroll" : "Enroll"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default PupilActivityEnrollmentModal;
